import { tv } from 'tailwind-variants'

import { h4 } from '@ui-kit/core/typography'

export const globalHeader = tv({
  slots: {
    container: 'flex h-14 flex-1 flex-row  items-center justify-center bg-ui-light px-2.5 py-2',
    contentWrapper: 'flex w-full max-w-screen-2xl flex-row items-center justify-between',
    leftContainer: 'flex flex-row items-center gap-x-2.5',
    elementsContainer: 'flex flex-row',
    title: h4({ className: 'mt-2 pl-2.5' }),
    anchor: 'flex items-center gap-x-2.5',
    logoContainer: 'relative inline-block h-6 w-[29px] lg:h-8 lg:w-[39px]',
    logoImg: 'absolute',
    wordMarkContainer: 'relative inline-block h-3 w-[97px] lg:h-4 lg:w-[130px]',
  },
})
